var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39308",
    "data-name": "Group 39308",
    transform: "translate(18386.646)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11760",
    "data-name": "Rectangle 11760",
    width: 24,
    height: 24,
    transform: "translate(-18386.646)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "email_1_",
    "data-name": "email (1)",
    transform: "translate(-18385.498 4.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26077",
    "data-name": "Group 26077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25016",
    "data-name": "Path 25016",
    d: "M19.154,76H1.846A1.848,1.848,0,0,0,0,77.846V88.92a1.848,1.848,0,0,0,1.846,1.846H19.154A1.848,1.848,0,0,0,21,88.92V77.846A1.848,1.848,0,0,0,19.154,76Zm-.283,1.23-7.894,7.92a.718.718,0,0,1-.954,0L2.129,77.23ZM1.23,88.694V78.072l5.294,5.311Zm.9.841,5.264-5.281,1.759,1.765a1.947,1.947,0,0,0,2.7,0l1.759-1.765,5.264,5.281Zm17.64-.841-5.294-5.311,5.294-5.311Z",
    transform: "translate(0 -76)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.25d0460d1de59a23ac0ae38ec4bf9084.svg";
export { ForwardRef as ReactComponent };